import { FormEvent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ForgotPassword = () => {
  const { configured, requestPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    document.title = "Reset password · Olivia Flemming";
  }, []);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const { error: err } = await requestPasswordReset(email.trim());
    setSubmitting(false);
    if (err) {
      setError(err);
      return;
    }
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <h1 className="font-playfair text-3xl text-white text-center mb-2">Reset password</h1>
        <p className="text-white/50 text-sm text-center mb-10 font-inter">
          We’ll email a secure link if that account exists.
        </p>

        {!configured && (
          <div className="mb-6 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-100/90">
            Configure Supabase env vars before password reset will work.
          </div>
        )}

        {sent ? (
          <div className="rounded-xl border border-primary/30 bg-primary/10 px-4 py-5 text-sm text-white/80 font-inter text-center">
            If an account exists for <strong className="text-white">{email}</strong>, a reset email is on its way.
            Check spam folders too.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label htmlFor="email" className="block text-xs uppercase tracking-widest text-white/50 mb-2">
                Email
              </label>
              <input
                id="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl bg-secondary border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-primary"
              />
            </div>
            {error && (
              <p className="text-sm text-red-300" role="alert">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={submitting || !configured}
              className="w-full rounded-full bg-primary text-black font-medium py-3.5 text-sm hover:bg-primary/90 disabled:opacity-50"
            >
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <div className="mt-6 text-center">
          <Link to="/admin" className="text-sm text-white/50 hover:text-primary font-inter">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
